<template>
  <v-card class="pa-8">
    <v-form ref="createForm" v-model="checkValidate" :lazy-validation="lazy">
      <h3>เพิ่มประเภทสินค้า</h3>
      <v-row>
        <v-col cols="2"><p class="pt-2">ชื่อประเภทสินค้า*</p></v-col>
        <v-col cols="6">
          <v-text-field
            v-model="typeName"
            label="ชื่อประเภทสินค้า"
            outlined
            dense
            :rules="rules.required"
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="2"><p class="pt-2">รายละเอียด*</p></v-col>
        <v-col cols="6">
          <v-text-field
            v-model="typeDescription"
            label="รายละเอียด"
            outlined
            dense
            :rules="rules.required"
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-btn @click="cancel()">กลับ</v-btn>
        <v-spacer></v-spacer>
        <v-btn @click="submit()">บันทึก</v-btn>
      </v-row>
    </v-form>
  </v-card>
</template>
<script>
import { Decode } from "@/services";
export default {
  data() {
    return {
      typeName: "",
      typeDescription: "",
      rules: {
        required: [(v) => !!v || "กรุณากรอกข้อมูล"],
      },
      checkValidate: true,
      lazy: false,
      user: "",
    };
  },
  methods: {
    cancel() {
      this.$router.push("ManageType");
    },
    async submit() {
      if (this.$refs.createForm.validate(true)) {
        this.user = JSON.parse(Decode.decode(localStorage.getItem("userForrent")));
        const auth = {
          headers: { Authorization: `Bearer ${this.user.token}` },
        };
        const data = {
          type: this.typeName,
          description: this.typeDescription,
        };
        const response = await this.axios.post(
          `${process.env.VUE_APP_API}/types`,
          data,
          auth
        );
        console.log("createType", response);
        console.log(response.data.response_status);
        if (response.data.response_status == "SUCCESS") {
          this.$swal.fire({
            icon: "success",
            text: `สร้างประเภทสินค้าสำเร็จ`,
            showConfirmButton: false,
            timer: 1500,
          });
          this.$router.push("ManageType");
        } else {
          this.$swal.fire({
            icon: "error",
            text: `สร้างประเภทสินค้าไม่สำเร็จ`,
            showConfirmButton: false,
            timer: 1500,
          });
        }
      }
    },
  },
};
</script>